import type { FinishStepReturn } from './hooks/useFinishStep';
import RingFinishChoice from './RingFinishChoice';

export const FinishStepRingFinishChoices = ({
  active,
  scrollRef,
  hasMaxRingCount,
  isOuraRing4Wizard,
  renderFinishes,
  selectedFinish,
}: Partial<FinishStepReturn>): JSX.Element => {
  return (
    <>
      {renderFinishes?.map((ring) => {
        const finish = ring.finish;
        return (
          <RingFinishChoice
            key={finish}
            active={active}
            scrollRef={scrollRef}
            hasMaxRingCount={hasMaxRingCount}
            isOuraRing4Wizard={isOuraRing4Wizard}
            selectedFinish={selectedFinish}
            ring={ring}
          />
        );
      })}
    </>
  );
};
